import React, {Component} from 'react'
import store, {history} from '../../../../../store'
import ConfirmPopup from "../../../../common/confirm-popup";
import IgniteDataTable from '../../../../common/datatable'
import {deleteArticle} from '../../../../../actions/news'
import {dateTimeFormat} from '../../../../../utils/commonFunctions'

class ArticlesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  handleDelete = (result) => {
    const id = this.state.delete.id;
    this.setState({delete: {show: false}});
    if (result) {
      store.dispatch(deleteArticle(id));
    }
  };

  render() {
    const columns = [
      {prop: 'title', title: 'Title', onClick: (data, row) => {
        store.dispatch({type: 'TOGGLE_EDIT_CONTENT'});
        history.push(`/article/${row.id}`);
      }},
      {prop: 'display-from-date', title: 'Display from', format(data, row) {return dateTimeFormat(data)}},
      {prop: 'display-to-date', title: 'Display to', format(data, row) {return dateTimeFormat(data)}},
      {prop: 'status', title: 'Status'},
    ];

    const actions = [
      {
        label:       'Settings',
        color:       'grey',
        permissions: {
          action:       'update',
          subjectClass: 'Article'
        },
        callback:    (row) => {
          history.push(`/admin/news/articles/${row.id}`);
        }
      },
      {
        label:       'Delete',
        permissions: {
          action:       'destroy',
          subjectClass: 'Article'
        },
        callback:    (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];

    return (
      <div>
      <IgniteDataTable data={this.props.articles}
                       columns={columns}
                       actions={actions}/>

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE NEWS ARTICLE?"
                        onClose={this.handleDelete}>
            <p>Are you sure you want to delete this news article?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

export default ArticlesList


// WEBPACK FOOTER //
// ./src/components/admin/news/articles/list/articles-list.jsx